import { useParams } from 'react-router-dom'
import { useGetTimesheetQuery as useGetTimesheetQueryApi } from '../../store/api/timesheet/timesheetDetailApi'

export const useGetTimesheetQuery = () => {
	const params = useParams()
	const rawId = Number(params.id ?? 0)
	const shouldSkip = isNaN(rawId) || rawId <= 0

	const { data, isLoading, isError, isFetching, refetch } = useGetTimesheetQueryApi(rawId, { skip: shouldSkip })
	return { data, isLoading, isError, isFetching, refetch }
}
